import { dcDueActions, userActions } from '_actions'
import { createReducer } from '@reduxjs/toolkit'

const initialState = {
};

export const reducer = createReducer(initialState, {
    [dcDueActions.loadSuccess]: (state, action) => {
        let result;
        result = action.payload.entities.dcdue ? action.payload.entities.dcdue : {};
        return result;
    },
    [userActions.loadSessionSuccess]: (state, action) => {
        let result;
        result = action.payload.dcdue.entities.dcdue ? action.payload.dcdue.entities.dcdue : {};
        return result;
    },
    [dcDueActions.markReadSuccess]: (state, action) => {
        state[action.payload].isRead = true;
    },
})


